import { Component, OnInit, ElementRef, ViewChild, Inject, ViewEncapsulation } from '@angular/core';

import * as DetectBrowser from 'detect-browser';
import * as MobileDetect from 'mobile-detect';
import { InterruptableTimer } from './model/interruptabletimer';
import { environment } from 'src/environments/environment';
import { DOCUMENT } from '@angular/common';
import { Lightbox } from 'ngx-lightbox';
import { EnvService } from './env.service';
import { CustomSymbolDialogService } from './components/dialogs/custom-symbol-dialog/custom-symbol-dialog.service';
import { FontService } from './model/api-services/font.service';
import { SandboxMessengerService } from './services/sandbox-messenger.service';

declare var root: HTMLElement;



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  @ViewChild('app_root', { static: true }) domNode: ElementRef;
  title = 'SimpleMap';
  messageText: string;
  resizeTimer: InterruptableTimer = new InterruptableTimer(750);
  public set isMobile(mobility: boolean) {
    this.domNode.nativeElement.classList.toggle('isMobile', mobility);
  }
  public get isMobile(): boolean {
    return this.domNode.nativeElement.classList.contains('isMobile');
  }

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private lb: Lightbox,
    private env: EnvService,
    private fonts: FontService,
    private sbmsgr: SandboxMessengerService
  ) {
    const divNode = document.createElement('div');

    divNode.style.width = '100px';
    divNode.style.height = '100px';
    divNode.style.overflow = 'scroll';
    divNode.style.position = 'absolute';
    divNode.style.top = '-1000px';
    divNode.style.left = '-1000px';

    const innerDiv = document.createElement('div');
    innerDiv.style.width = '200px';
    innerDiv.style.height = '200px';

    divNode.appendChild(innerDiv);
    document.body.appendChild(divNode);

    const scrollBarWidth =
      divNode.offsetWidth - divNode.clientWidth;

    const scrollBarHeight =
      divNode.offsetHeight - divNode.clientHeight;

    document.documentElement.style.setProperty(
      '--scrollbar-width',
      `${scrollBarWidth}px`
    );

    document.documentElement.style.setProperty(
      '--scrollbar-height',
      `${scrollBarHeight}px`
    );

    divNode.remove();

    this.env.SetApp(this);
  }

  ngOnInit() {

    const bases = this.document.getElementsByTagName('base');
    this.document.body.addEventListener('preview-media', (event: CustomEvent) => {
      if (!event.detail || !event.detail.url) {
        return;
      }
      const url = event.detail.url;
      const album: Array<any> = [];
      album.push({
        src: url,
        caption: url
      })
      this.lb.open(album, 0);
    })
    if (bases.length > 0) {
      bases[0].setAttribute('href', environment.baseHref);
    }
    const md = new MobileDetect(window.navigator.userAgent);
    $('body').toggleClass('is-mobile', md.mobile() !== null);
    const viewportmeta = document.querySelector('meta[name="viewport"]');
    viewportmeta.setAttribute('content', 'user-scalable=0, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, width=device-width, height=device-height');


    const browser = DetectBrowser.detect();
    switch (browser && browser.name) {
      case 'ie':
      // this.router.navigate(['/browsers'], { replaceUrl: false, skipLocationChange: true });
      // return;
    }
    window.addEventListener('resize', (event: any) => {
      if (event.currentTarget.scale !== 1) {
        event.preventDefault();
      }
      this.onResize();
    });
    this.onResize();
    function isHighDensity() {
      return ((window.matchMedia &&
        // tslint:disable-next-line:max-line-length
        (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches
          // tslint:disable-next-line: max-line-length
          || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches))
        || (window.devicePixelRatio && window.devicePixelRatio > 1.3));
    }


    function isRetina() {
      // tslint:disable-next-line: max-line-length
      return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches)) || (window.devicePixelRatio && window.devicePixelRatio >= 2)) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
    }


    $(document.body).toggleClass('display-hd', isHighDensity());
    $(document.body).toggleClass('display-retina', isRetina());
    document.body.classList.toggle('awesomeless', true);
    this.env.AwesomeCheck();

  }


  onResize() {
    //this.resizeTimer.Start(() => {
    document.body.classList.toggle('resizing', true);
    const vh = window.innerHeight * .01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    document.documentElement.style.setProperty('--fh', 'calc(100 * var(--vh, 1vh))');
    //this.document.body.style.setProperty('height','calc(var(--vh) * 100)');
    const viewportmeta = document.querySelector('meta[name="viewport"]');
    viewportmeta.setAttribute(
      'content',
      'initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, width=device-width, height=device-height'
    );



    const width: number = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const height: number = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    document.documentElement.style.setProperty('--fw', width + 'px');

    const isHorizontal: boolean = width >= height;
    const isVertical: boolean = height > width;

    let prefix = 'xs';
    const breakPoints: Array<number> = [576, 768, 992, 1200];
    const breakPointPrefixes: Array<string> = ['sm', 'md', 'lg', 'xl'];
    $(document.body).toggleClass('xs', false);
    $(document.body).toggleClass('gt-xs', false);
    $(document.body).toggleClass('sm', false);
    $(document.body).toggleClass('gt-sm', false);
    $(document.body).toggleClass('md', false);
    $(document.body).toggleClass('gt-md', false);
    $(document.body).toggleClass('lg', false);
    $(document.body).toggleClass('gt-lg', false);
    $(document.body).toggleClass('xl', false);

    const compareTo = width;
    if (compareTo >= breakPoints[0]) {
      $(document.body).toggleClass('gt-xs', true);
    }
    for (let i = 0, l = breakPoints.length; i < l; i++) {
      if (breakPoints[i] < compareTo) {
        prefix = breakPointPrefixes[i];
        $(document.body).toggleClass('gt-' + prefix, true);
      }
    }
    $(document.body).toggleClass('gt-' + prefix, false);

    $(document.body).toggleClass(prefix, true);
    $(document.body).toggleClass('is-vertical', isVertical);
    $(document.body).toggleClass('is-horizontal', isHorizontal);
    document.body.classList.toggle('resizing', false);
    console.log('resized');

    // });
  }
}


